import axios from "axios";
import Api from "../axios";

export const getBonusList = async () => {
  return await axios.get(
    `${process.env.REACT_APP_BASE_URL}/admin/get-all-first-deposit-bonus`
  );
};
